<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Création des <strong>agences</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="ville">Ville </label>
              <b-form-input type="text" v-model="agency.ville" placeholder="Ville"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="commune">Commune </label>
              <b-form-input type="text" v-model="agency.commune" placeholder="Commune"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="telephone">Téléphone </label>
              <b-form-input type="text"  v-model="agency.telephone" placeholder="Telephone"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="nom">Nom *</label>
              <b-form-input type="text"  v-model="agency.nom_agence" placeholder="Nom de l'agence ... "></b-form-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="12" v-if="display_entity">
              <label for="entite_id">Entité *</label>
              <b-form-select id="entite_id" :plain="true" :options="options" v-model="agency.entite_id" selected disabled>
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="12">
              <label for="description">Description</label>
               <textarea id="description" placeholder="Description" v-model="agency.description" rows="3" max-rows="6" class="form-control"></textarea>
            </b-col>
          </b-row>
          <div slot="footer">
            <span v-if="can('agence-create')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <span><b-button  @click="goBack" type="reset" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button></span>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      //options : [{ value: 'Distributeur', text: 'Distributeur' },{ value: 'Poste', text: 'Poste' }],
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      display_entity :true,
      agency:{
            ville: '',
            commune: '',
            telephone: '',
            nom_agence: '',
            entite_id: '',
            description: ''
      },
      entities:[],
      serverParams: {
        page:1,
        current_page: 1,
        paginate: 10
      }
    }
  },
  methods:{
    goBack() {
      this.$router.go(-1)
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    async post(){     
        this.response = await this.$store.dispatch('agency/post_agency',this.agency)
        this.showAlert()
        this.reset()
    },
    async get_all_entities(){
          //this.entities =  store.getters['entity/rows'];
          if(this.$route.params.entite_id === null || this.$route.params.entite_id === 'null'){
            await this.$store.dispatch('entity/get_all_authentites',this.serverParams).then(()=>{
              return this.entities = store.getters['entity/rows'];    
            })
            this.display_entity = true
            this.entities.forEach((element)=>{     
                this.options.push({
                  value:element.id,
                  text:element.typeentite_libelle.toUpperCase()+' : '+element.nom_commercial.toUpperCase(),
                })
            })
            if (this.options.length==1){
              this.agency.entite_id=this.options[0].value
            }
          }else{
            this.display_entity =false
            this.agency.entite_id = this.$route.params.entite_id
            this.options.push({
              value:this.$route.params.entite_id,
              text:this.$route.params.entite_id
            })
          }
    }, 
    reset(){
        this.agency.ville= '',
        this.agency.commune= '',
        this.agency.telephone= '',
        this.agency.nom_agence= '',
        this.agency.description=''
    },
    can(perm){
        return store.getters['auth/can'](perm)
    }
  },
  mounted(){
    this.get_all_entities()
    //this.get_all_agencies()
  }
}
</script>
